<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>     

              <v-flex xs12 sm6 md6>
                <span style="color: gray;font-size: 13px;">Version Number</span>
                <input id="nextVersionNumber" type="text" :value="formSchema.nextVersionNumber" readonly="readonly" style="width: 100%;border-bottom: 1px solid gray;line-height: 28px;">
                <!-- <v-text-field
                  label="Version Number"
                  v-model="formSchema.version_no"                      
                  :rules="[v => !!v || 'Version number is required !',number, lng3]"
                  type="number"
                  @input="checkVersionNumber(formSchema.version_no)"
                  required
                ></v-text-field> -->
                <span v-html="message"></span>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'versioning_date', fieldValue:formSchema.versioning_date, label:'Versioning Date',required:1}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Name of the Document"
                  v-model="formSchema.document_name"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                Upload File
                <input
                  type="file"
                  id="files2"
                  ref="image2"
                  v-on:change="handleFilesUpload()"
                />
              </v-flex>

               <!-- <v-flex xs12 sm6 md6 >
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
              </v-flex> -->

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>      
        
          <v-spacer></v-spacer>
          <v-btn v-if="saveBtn" color="success" @click.native="validateBeforeSubmit"  :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <!-- -->
          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
let utilities = require("../../../utilities/utilities");
import DatePicker from "../../global/date_picker";

export default {
  props: ["formSchema"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    is_activeVal:1,
    message:'',
    documentFiles: [],
    saveBtn:true,
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Edit Package Version" : "Add Package Version";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
    commonService.getAllData("package-version").then(res => {
        this.desserts = res.data;
        this.formSchema.nextVersionNumber = res.nextVerNumber;
    });
  },

  methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    validateBeforeSubmit(e) {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    checkVersionNumber(vNong){      
      let desserts = this.desserts;
      if(desserts.length > 0)
      {
        if (vNong) {
          let vNum = desserts.filter(function(a) {
            return a.version_no == vNong;
          })[0];

          if(vNum === undefined)
            {
              this.message = '';
              this.saveBtn = true       
            }
            else
            {                            
              this.message = '<span style="color:#ff5252;font-size: 12px;">Version number already exist!</span>';
              this.saveBtn = false;        
            }

        }
        else
        {
          this.message = '';
        }
      }

    },

    submitForm() {
      let formData = new FormData();
      var formSchema = this.formSchema;
      formSchema.version_no = document.getElementById("nextVersionNumber").value;
      formSchema.versioning_date = this.changeFormateYMD(
        this.formSchema.versioning_date
      );
      
      for (var i = 0; i < this.documentFiles.length; i++) {
        let file = this.documentFiles[i];
        formData.append("files[" + i + "]", file);
      }
      
      formSchema.record_id = sessionStorage.getItem("mm_id");
      formSchema.sub_menu_id = sessionStorage.getItem("sm_id");

      formData.append("fieldValues", JSON.stringify(formSchema));

      commonService.insertFormData(formData, "package-version").then(res => {
        let actionData = {
          message: res.message,
          data: res.data,
          action: res.action,
          status: res.status
        };
        if (res.status == 1) {
          this.documentFiles = [];
          document.getElementById("files2").value = null;
          this.formSchema.id = 0;
          this.$refs.form.reset();
          this.formSchema.versioning_date = ''   
          this.formSchema.nextVersionNumber = Number(res.version_no)+1   
        }
        else
        {
          this.formSchema.versioning_date = this.changeFormateDMY(
            this.formSchema.versioning_date
            );
        }
        this.close(actionData);
      });
    },

    handleFilesUpload() {
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      //console.log("uploadedFiles", uploadedFiles);

      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG|\.pdf|\.doc|\.docx)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {
        this.message = "You can upload jpg, jpeg, png, pdf, doc and docx file only";
        this.snackbar = true;
        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.documentFiles.push(uploadedFiles[i]);
        }
      }
    },

    resetForm(){      
      //this.$refs.form.reset();
      this.formSchema.id = 0;        
    },

    close: function(data) {
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/procurement/package_version/insertForm.vue